export const defaultAttributes = {
    color: 'green',
    style: 'filled',
    textfieldError: 'Enter a valid email address.',
    title: 'Unlock Mortgage Mojo',
    description:
        'Smart reads, solid advice, and zero fluff. Sign up and become your own home-financing hero.',
    buttonText: 'Make Me Mortgage-Savvy',
    altText: 'fashionable women wearing sunglasses',
    successTitle: 'You’re On the List!',
    successDescription:
        'Smart reads, solid advice, and zero fluff. Sign up and become your own home-financing hero.',
    featureFlag: 'email-capture',
    placeholder: 'Email Address',
};

export const testAttributes = {
    EMAIL_CAPTURE_CONTAINER: 'email-capture-container',
    EMAIL_CAPTURE_FORM_CONTAINER: 'email-capture-form-container',
    EMAIL_CAPTURE_SUCCESS_CONTAINER: 'email-capture-success-container',
    EMAIL_CAPTURE_INPUT: 'email-capture-input',
    EMAIL_CAPTURE_BUTTON: 'email-capture-button',
    EMAIL_CAPTURE_IMAGE: 'email-capture-image',
    EMAIL_CAPTURE_TITLE: 'email-capture-title',
    EMAIL_CAPTURE_SUCCESS_TITLE: 'email-capture-success-title',
    EMAIL_CAPTURE_DESCRIPTION: 'email-capture-description',
    EMAIL_CAPTURE_SUCCESS_DESCRIPTION: 'email-capture-success-description',
    title: 'Join Our Newsletter',
    description: 'Get the latest tips.',
    buttonText: 'Subscribe Now',
    altText: 'image alt text',
};